import { createFileRoute } from "@tanstack/react-router";
import { AzureCallback } from "../../../features/infrastructure/cloud-connect";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/azure_/callback")({
  validateSearch: (s: Record<string, unknown>) => ({
    account: typeof s.account === "string" ? s.account : undefined,
    code: typeof s.code === "string" ? s.code : undefined,
    state: typeof s.state === "string" ? s.state : undefined,
    result: typeof s.result === "string" ? s.result : undefined,
    message: typeof s.message === "string" ? s.message : undefined,
  }),
  component: Page,
});

function Page() {
  const { org } = Route.useParams();
  return <AzureCallback org={org} search={Route.useSearch()} />;
}
